
import Login from '@/views/login/login.vue'
import Home from '@/views/home/index.vue'
import userList from '@/views/user/userList.vue'
import userEdit from '@/views/user/edit.vue'
import userEdit1 from '@/views/firm/edit1.vue'
import userEdit2 from '@/views/firm/edit2.vue'
import firmList from '@/views/firm/firmList.vue'
import signList from '@/views/sign/signList.vue'
import reportList from '@/views/report/reportList.vue'


const mainMap = [
    {
        path: '/',
        name: 'Index',
        redirect: '/login',
        meta: { auth: true },
        component: Home
    },
    // 识别上报
    {
        path: '/report',
        redirect: '/report/reportList',
        meta: { auth: true},
        component: Home,
        children: [
            {
                path: 'reportList', 
                name: 'reportList',
                component: reportList,
            }
        ]
    },
    // 个人认证
    {
        path: '/user',
        redirect: '/user/userList',
        meta: { auth: true},
        component: Home,
        children: [
            {
                path: 'userList', 
                name: 'userList',
                component: userList,
            }, {
                path: 'edit/:id', 
                name: 'edit',
                component: userEdit,
            }
        ]
    },
    // 企业认证
    // {
    //     path: '/firm',
    //     redirect: '/firm/firmList',
    //     meta: { auth: true},
    //     component: Home,
    //     children: [
    //         {
    //             path: 'firmList', 
    //             name: 'firmList',
    //             component: firmList,
    //         }, {
    //             path: 'edit1/:id', 
    //             name: 'edit1',
    //             component: userEdit1,
    //         }, {
    //             path: 'edit2/:id', 
    //             name: 'edit2',
    //             component: userEdit2,
    //         }
    //     ]
    // },
    // 用户注册
    {
        path: '/sign',
        redirect: '/sign/signList',
        meta: { auth: true},
        component: Home,
        children: [
            {
                path: 'signList', 
                name: 'signList',
                component: signList,
            }
        ]
    },
    {
        path: '/login',
        name: 'login',
        meta: { auth: true },
        component: Login
    },


]
export default [
    ...mainMap
]